export default __webpack_public_path__ + "static/media/GasMask.64.5d72634a.png";